import { render, staticRenderFns } from "./Trace.vue?vue&type=template&id=70da2665&scoped=true&"
import script from "./Trace.vue?vue&type=script&lang=js&"
export * from "./Trace.vue?vue&type=script&lang=js&"
import style0 from "./Trace.vue?vue&type=style&index=0&id=70da2665&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da2665",
  null
  
)

export default component.exports